module.exports = __webpack_public_path__ + "static/media/asurion_logo_black_rgb.3f4710a7.svg";